import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import avo from 'analytics/avo';
import useIsTouchDevice from 'hooks/useIsTouchDevice';
import MaterialThumbnailUI from './MaterialThumbnailUI';

const MaterialThumbnail = ({
  color,
  customToggleFlyOut = false,
  customToggleFlyOutData = null,
  fabricFavProps = {},
  fullHeightThumbnail = false,
  image,
  isDisabled = false,
  isFavMaterial,
  isInFlashSale = false,
  isRound = false,
  isSelected,
  label,
  loading,
  materialApplicableForProduct = true,
  materialId,
  onClick,
  onHover,
  show = true,
  toggleFlyOut,
  upholsteryOptionId,
  variant,
}) => {
  const {
    actions: { setOptionAsFav, removeOptionAsFav } = {},
    data: { favProductData } = {},
  } = fabricFavProps;

  const favParams = setOptionAsFav
    ? {
        fabricId: materialId,
        fabricName: label,
        fabricColor: color,
        location: 'PDP',
        ...favProductData,
      }
    : {};

  const isTouchDevice = useIsTouchDevice();
  const lastTapRef = useRef(null);
  const DOUBLE_PRESS_DELAY = 300;

  return (
    <MaterialThumbnailUI
      show={show}
      image={image}
      isSelected={isSelected}
      label={label}
      loading={loading}
      fullHeightThumbnail={fullHeightThumbnail}
      variant={variant}
      onClick={
        materialApplicableForProduct
          ? evt => {
              evt.preventDefault();
              evt.stopPropagation();

              if (!isSelected) {
                if (typeof onClick === 'function') {
                  onClick(upholsteryOptionId, materialId, 'customizer');
                }
              } else {
                if (!isTouchDevice || !setOptionAsFav || !removeOptionAsFav) {
                  return;
                }
                // comes here for mobile/tablet double tap handling.
                if (
                  lastTapRef?.current &&
                  Date.now() - lastTapRef.current < DOUBLE_PRESS_DELAY
                ) {
                  if (isFavMaterial) {
                    removeOptionAsFav(materialId);
                    avo.fabricUnfavorited(favParams);
                  } else if (!isFavMaterial) {
                    setOptionAsFav(materialId);
                    avo.fabricFavorited(favParams);
                  }

                  lastTapRef.current = null;
                } else {
                  lastTapRef.current = Date.now();
                }
              }
            }
          : null
      }
      onDblClick={evt => {
        evt.preventDefault();
        evt.stopPropagation();
        if (isTouchDevice || !setOptionAsFav || !removeOptionAsFav) {
          return;
        }
        if (isSelected || !materialApplicableForProduct) {
          if (isFavMaterial) {
            if (typeof toggleFlyOut === 'function') {
              toggleFlyOut(false, materialId);
            }
            removeOptionAsFav(materialId);
            avo.fabricUnfavorited(favParams);
          } else {
            setOptionAsFav(materialId);
            avo.fabricFavorited(favParams);
          }
        }
      }}
      onHover={onHover ? () => onHover(upholsteryOptionId, materialId) : null}
      toggleFlyOut={toggleFlyOut}
      materialId={materialId}
      isRound={isRound}
      isDisabled={isDisabled}
      isFavMaterial={isFavMaterial}
      customToggleFlyOut={customToggleFlyOut}
      customToggleFlyOutData={customToggleFlyOutData}
      isInFlashSale={isInFlashSale}
      materialApplicableForProduct={materialApplicableForProduct}
    />
  );
};

MaterialThumbnail.propTypes = {
  color: PropTypes.string,
  customToggleFlyOut: PropTypes.bool,
  customToggleFlyOutData: PropTypes.object,
  fabricFavProps: PropTypes.object,
  fullHeightThumbnail: PropTypes.bool,
  image: PropTypes.string,
  isDisabled: PropTypes.bool,
  isFavMaterial: PropTypes.bool,
  isInFlashSale: PropTypes.bool,
  isRound: PropTypes.bool,
  isSelected: PropTypes.bool,
  label: PropTypes.string,
  loading: PropTypes.bool,
  materialApplicableForProduct: PropTypes.bool,
  materialId: PropTypes.number,
  onClick: PropTypes.func,
  onHover: PropTypes.func,
  show: PropTypes.bool,
  toggleFlyOut: PropTypes.func,
  upholsteryOptionId: PropTypes.number,
  variant: PropTypes.oneOf([
    'PDPCustomerPhotosReviewsModal',
    'PDPShownInUI',
    'PDPShownInUI--grey-background',
  ]),
};

export default MaterialThumbnail;
